import React from 'react';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useUI from 'hooks/use-ui';
import { useDispensaryCategory } from 'src/hooks/use-dispensary-category';
import { useDispensarySubcategory } from 'src/hooks/use-dispensary-subcategory';
import { useProductsForCategoryPage } from 'src/dispensary/hooks/use-products-for-category-page';

import JsonLDScript from './json-ld/json-id-script';

export default function CategoryTags() {
  const { dispensary } = useDispensary();
  const UI = useUI();
  const category = useDispensaryCategory();
  const { subcategory } = useDispensarySubcategory();
  const { products, totalCount } = useProductsForCategoryPage({ perPage: UI.isKiosk ? 20 : 100 });

  if (!dispensary?.cName || !products?.length) {
    return null;
  }

  return (
    <JsonLDScript variant='categoryPage' jsonLdData={{ dispensary, category, subcategory, products, totalCount }} />
  );
}
